import React from 'react'
import TradingInterface from '@/components/TradingInterface'

/**
 * Trading page - Shows chore trading interface
 * Route: /dashboard/trading
 */
export const TradingPage: React.FC = () => {
  return <TradingInterface />
}
